<template>
  <section class="card mt-3 mb-2" v-if="diaryData.length">
    <div class="card-header card-header-light d-flex justify-content-between">
      <h4 class="card-header__title">{{ $t('src/components/training/trainingmanage.4394') }}</h4>

      <div class="card-header__month-pagination d-flex flex-row">
        <div class="dropdown-container">
          <div v-if="isCanSwitchPeriod">
            <button
              type="button"
              class="btn btn-vertical btn-with-icon"
              @click="prevPeriod"
              :disabled="false"
            >
              <svg-icon
                class="svg-icon right-turn"
                :name="'arrow-right'"
                :isDisabled="false"
                :width="15"
                :height="15"
              ></svg-icon>
            </button>
            <button
              type="button"
              class="btn btn-vertical btn-with-icon"
              @click="nextPeriod"
              :disabled="!isCanScrollNext"
            >
              <svg-icon
                class="svg-icon"
                :name="'arrow-right'"
                :IsDisabled="!isCanScrollNext"
                :width="15"
                :height="15"
              ></svg-icon>
            </button>
          </div>
          <base-dropdown-select
            :options="listOfTimeData"
            v-model="timeData"
            class="form-control min-size ml-2"
            style="min-width: 120px;"
          ></base-dropdown-select>
        </div>

        <base-calendar-wrap v-if="isCanSwitchPeriod" :is-small="true" class="ml-2" style="width: auto;">
          <date-input
            :value="selectedDate"
            @input="changeSelectedDate"
            :max-date="nowFormatServer"
          ></date-input>
        </base-calendar-wrap>

        <div class="mr-3 ml-3" style="border-left: 1px solid #D9D9DD;"></div>

        <div class="btn-group">
          <button
            type="button"
            class="btn btn-outline-none btn-with-icon"
            :class="diaryView === 'line' ? 'btn-secondary-light' : 'btn-outline-secondary'"
            @click="setViewReport('line')"
            :title="$t('src/components/training/trainingmanage.1')"
          >
            <svg-icon :name="'menu_burger'"></svg-icon>
          </button>
          <button
            type="button"
            class="btn btn-outline-none btn-with-icon"
            :class="diaryView === 'graph' ? 'btn-secondary-light' : 'btn-outline-secondary'"
            @click="setViewReport('graph')"
            :title="$t('src/components/training/trainingmanage.3')"
          >
            <svg-icon :name="'graph'"></svg-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="diaryData.length">
      <diary-graph
        v-show="diaryView === 'graph'"
        :diary-data="diaryData"
        :activeTimeData="+timeData"
        :selectedDate="selectedDate"
      ></diary-graph>
      <diary-table
        v-show="diaryView === 'line'"
        :diary-data="diaryData"
        :activeTimeData="+timeData"
        :selectedDate="selectedDate"
      >
      </diary-table>
    </div>
  </section>
</template>

<script>
import http from '@/modules/http'
import { stringify } from 'qs'
import { messageTypes, timePeriods } from '@/main.config'
import { nowMoment } from '@/mixins/now-moment'

import SvgIcon from '@/components/SvgIcon.vue'
import BaseDropdownSelect from '@/base/BaseDropdownSelect.vue'
import DateInput from '@/plugins/DateInput.vue'
import BaseCalendarWrap from '@/base/BaseCalendarWrap.vue'
import DiaryGraph from '@/components/DiaryGraph.vue'
import DiaryTable from '@/components/DiaryTable.vue'

export default {
  name: 'PatientDiary',
  components: {
    DiaryGraph,
    DiaryTable,
    SvgIcon,
    BaseDropdownSelect,
    DateInput,
    BaseCalendarWrap
  },
  mixins: [nowMoment],
  data: function() {
    return {
      diaryData: [],
      diaryView: null,
      listOfTimeData: {
        1: this.$t('courseReport.allTime'),
        2: this.$t('courseReport.oneDay'),
        3: this.$t('courseReport.oneWeek'),
        4: this.$t('courseReport.oneMonth'),
        5: this.$t('courseReport.threeMonth')
      },
      timeData: 1,
      selectedDate: null
    }
  },
  computed: {
    isCanSwitchPeriod() {
      return [timePeriods.oneDay, timePeriods.oneWeek].includes(+this.timeData)
    },
    isCanScrollNext() {
      const currentDate = new Date()
      const selectedDate = this.selectedDate
      if (selectedDate.getTime() < currentDate.getTime()) {
        return true
      } else return false
    }
  },
  created() {
    const currentDate = new Date()
    this.selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
    this.setStorageDiaryView()
    this.loadData().then(diaryData => {
      this.diaryData = diaryData.data.map(item => {
        return {
          content: JSON.parse(item.content),
          createdAt: item.createdAt
        }
      })
    })
  },
  methods: {
    loadData() {
      return new Promise(resolve => {
        http
          .get('/messages', {
            params: {
              course_id: +this.$route.params.id,
              type: { $in: [messageTypes.diary] },
              $limit: 1000 //TODO
            },
            paramsSerializer: params =>
              stringify(params, {
                arrayFormat: 'indices',
                encodeValuesOnly: true
              })
          })
          .then(response => response.data)
          .then(data => {
            resolve(data)
          })
          .catch(error => console.log(error))
      })
    },
    setStorageDiaryView() {
      this.diaryView = 'graph'
    },
    setViewReport(view) {
      this.diaryView = view
    },
    changeSelectedDate(date) {
      const parts = date.split('-')
      const year = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const day = parseInt(parts[2], 10)
      const dateObject = new Date(year, month, day)
      this.selectedDate = dateObject
    },

    nextPeriod() {
      let numberOfDay = this.getNumberOfDayByTimeDate()
      let newSelectedDate = this.changeSelectedDateByArrow(numberOfDay)
      let currentDate = new Date()
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      this.selectedDate = newSelectedDate.getDate() > currentDate.getDate() ? currentDate : newSelectedDate
    },
    prevPeriod() {
      let numberOfDay = this.getNumberOfDayByTimeDate()
      this.selectedDate = this.changeSelectedDateByArrow(-numberOfDay)
    },
    changeSelectedDateByArrow(numberOfDay) {
      return new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate() + numberOfDay
      )
    },
    getNumberOfDayByTimeDate() {
      switch (+this.timeData) {
        case timePeriods.oneDay:
          return 1
        case timePeriods.oneWeek:
          return 7
        case timePeriods.oneMonth:
          return 30
      }
    }
  }
}
</script>
